import { ListItemText, ListItemTextProps } from '@mui/material'
import React, { FC } from 'react'

const ListItemTextWrapper: FC<ListItemTextProps> = ({ ...props }) => <ListItemText {...props} />

export default ListItemTextWrapper
